import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TrainingCourseSection } from 'app/_models/training/training-course-section.model';
import { NotificationService } from 'app/_services/notification.service';
import { TrainingService } from 'app/_services/training.service';
import { Globals } from './../../../_globals';

@Component({
  selector: 'questions-page',
  templateUrl: './questions-page.component.html',
})
export class QuestionsPageComponent implements OnInit {
  public routeRole: any;
  public routeParams: any;
  public trainingId: any;
  public sectionId: any;
  public section: TrainingCourseSection;
  public questionsArray = [];

  public isExpanded = true;

  constructor(
    public fb: FormBuilder,
    public router: Router,
    public globals: Globals,
    private activatedRoute: ActivatedRoute,
    private trainingService: TrainingService,
    private notificationService: NotificationService
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.trainingId = parseInt(params.trainingId);
      this.sectionId = parseInt(params.sectionId);
      this.routeParams = activatedRoute.snapshot.data.breadcrumbs;
    });

    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
    this.getSectionData();
  }

  // Questions Actions

  public addQuestion() {
    this.questionsArray.push({
      question: {
        text: '',
        order: this.questionsArray.length + 1,
        courseSectionId: this.sectionId,
      },
      answers: [],
    });
  }

  public addAnswer(question: any) {
    question.answers.push({
      text: '',
      correct: false,
    });
  }

  public editQuestion(value, question, i) {
    question.question.text = value;
  }

  public editAnswer(value, question, answer, i, j) {
    answer.text = value;
  }

  public setAnswerAsCorrect(value, question, answer, i, j) {
    answer.correct = value;
  }

  public removeQuestion(question) {
    this.questionsArray = this.questionsArray.filter((q) => q !== question);
  }

  public removeAnswer(question, answer) {
    question.answers = question.answers.filter((a) => a !== answer);
  }

  public cancel() {
    this.router.navigate(['/' + this.routeRole + '/training/' + this.trainingId + '/edit']);
  }

  // Submit

  public getSectionData() {
    this.trainingService.getTrainingCourseById(this.trainingId).subscribe(
      (course) => {
        this.section = course.getSectionById(this.sectionId);

        // deep clone of array
        this.questionsArray = JSON.parse(JSON.stringify(this.section.questions));
      },
      (error) => {
        console.error(error);
        this.notificationService.notify('danger', 'Error', 'Could not load existing section data');
      }
    );
  }

  public saveQuestions() {
    if (!this.validQuestionsAsnwers()) {
      this.notificationService.notify('danger', 'Error', 'Error could not save questions');
      return;
    }

    const body = this.questionsArray.map(question => ({
      question: question.question.text,
      order: question.question.order,

      questionAnswers: question.answers.map((answer) => ({
        answer: answer.text,
        correct: answer.correct,
      }))
    }));
    return this.trainingService.replaceQuestions(this.sectionId, body).subscribe(
      (response) => {
        this.router.navigate(['/' + this.routeRole + '/training/' + this.trainingId + '/edit']);
        this.notificationService.notify('success', 'Success', 'Questions saved');
      },
      (error) => {
        console.error(error);
        throw error;
      }
    );
  }

  public validQuestionsAsnwers() {
    let anyAnswersInvalid = false;
    let anyAnswersEmpty = false;
    let anyAsnwersNotCheckedCorrect = false;

    let numberOfCheckAnswers = 0;

    if (this.questionsArray.length === 0) {
      return false;
    }

    if (this.questionsArray.some((question) => question.question.text === '')) {
      this.notificationService.notify('danger', 'Error', 'Questions field cannot be empty');
      return false;
    }

    this.questionsArray.forEach((question) => {
      if (question.answers.length < 2) {
        anyAnswersInvalid = true;
      }
    });

    if (anyAnswersInvalid) {
      this.notificationService.notify('danger', 'Error', 'Questions cannot be created without answers');
      return false;
    }

    this.questionsArray.forEach((question) => {
      numberOfCheckAnswers = 0;
      question.answers.forEach((answer) => {
        answer.text === '';

        if (answer.text === '') {
          anyAnswersEmpty = true;
        }

        if (answer.correct === true) {
          numberOfCheckAnswers++;
        }
      });

      if (numberOfCheckAnswers != 1) {
        anyAsnwersNotCheckedCorrect = true;
      }
    });

    if (anyAnswersEmpty) {
      this.notificationService.notify('danger', 'Error', 'Answers field cannot be empty');
      return false;
    }

    if (anyAsnwersNotCheckedCorrect) {
      this.notificationService.notify('danger', 'Error', 'Answers cannot be created without correct field selected');
      return false;
    }

    return true;
  }
}
